module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0127.jpg?v=881688c2";